export default __webpack_public_path__ + "static/media/ame-logo.e3171702.svg";